import { render, staticRenderFns } from "./FleetVehicleView.vue?vue&type=template&id=5d7d0bb9&scoped=true&"
import script from "./FleetVehicleView.vue?vue&type=script&lang=ts&"
export * from "./FleetVehicleView.vue?vue&type=script&lang=ts&"
import style0 from "./FleetVehicleView.vue?vue&type=style&index=0&id=5d7d0bb9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7d0bb9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VChip,VCol,VIcon,VRow,VSkeletonLoader})
